import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'sn-invite-status',
  templateUrl: './invite-status.component.html',
  styleUrls: ['./invite-status.component.sass']
})
export class InviteStatusComponent {
  @Output() showPushedLogE = new EventEmitter<any>();

  @Input() status: any = {};
  @Input() isShow = true;
  @Input() isGroup = false;

  @HostBinding('class') hostClass = 'status';

  constructor() {}

  showPushedbackLog(pushedbackLog) {
    this.showPushedLogE.emit(pushedbackLog);
  }
}
